export default {
  summary: null,
  loading: false
};
